/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const es_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const de_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 Min`)
};

const nl_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const fr_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const it_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const pt_br2_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const pt_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 min`)
};

const ja_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分未満`)
};

const zh_wc_lt_1min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 1 分钟`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_lt_1min = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_lt_1min(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_lt_1min", locale)
	if (locale === "en") return en_wc_lt_1min(inputs)
	if (locale === "es") return es_wc_lt_1min(inputs)
	if (locale === "de") return de_wc_lt_1min(inputs)
	if (locale === "nl") return nl_wc_lt_1min(inputs)
	if (locale === "fr") return fr_wc_lt_1min(inputs)
	if (locale === "it") return it_wc_lt_1min(inputs)
	if (locale === "pt-BR") return pt_br2_wc_lt_1min(inputs)
	if (locale === "pt") return pt_wc_lt_1min(inputs)
	if (locale === "ja") return ja_wc_lt_1min(inputs)
	return zh_wc_lt_1min(inputs)
};